module.exports = __webpack_public_path__ + "img/utilityheavy_stopped.33dd4698.svg";